<template>
  <div>
    <!-- 修改用户信息-姓名   -->
    <el-drawer :visible.sync="nameSetupInside" :title="$t('name')" size="85%" class="search-dialog" :with-header="false" :modal="false" @close="dialog_close('nameSetup')">
      <div style="height:60px; background-color:rgba(79, 76, 76, 1);">
        <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;">{{$t('name')}}</div>
      </div>
      <div class="account-detail-main">
        <div class="notice"></div>
        <div class="account-detail-main-line">
          <div class="account-detail-main-line-center">
            <div class="title">{{ $t('lastName') }}</div>
            <div class="clearBoth account-roominfo-clear-5"></div>
            <el-input v-model.trim="lastnameInside" :placeholder="$t('lastName')" ref="lastName" @blur="checkEnglish('lastName')"></el-input>
            <div class="errorNotice" v-show="lastnameError">{{$t('pleaseTextEnglish')}}</div>
          </div>
        </div>
        <div class="account-detail-main-line">
          <div class="account-detail-main-line-center">
            <div class="title">{{ $t('firstName') }}</div>
            <div class="clearBoth account-roominfo-clear-5"></div>
            <el-input v-model.trim="firstnameInside" :placeholder="$t('firstName')" ref="firstName" @blur="checkEnglish('firstName')"></el-input>
            <div class="errorNotice" v-show="firstnameError">{{$t('pleaseTextEnglish')}}</div>
          </div>
        </div>
        <div class="button">
          <!--修改姓名-取消按钮-->
          <el-button class="buttonCancel width35" @click="nameSetupInside=false">{{ $t('buttonCancel') }}</el-button>
          <!--修改姓名-确定按钮-->
          <el-button class="buttonSave width55" @click="editAccount()">{{ $t('buttonSave') }}</el-button>
        </div>
      </div>
    </el-drawer>
    <div style="clear:both"></div>

    <!-- 修改用户信息-邮箱   -->
    <el-drawer :visible.sync="emailSetupInside" :title="$t('email')" size="85%" class="search-dialog" :with-header="false" :modal="false" @close="dialog_close('emailSetup')">
      <div style="height:60px; background-color:rgba(79, 76, 76, 1);">
        <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;">{{$t('email')}}</div>
      </div>
      <div class="account-detail-main">
        <div class="notice">
          <!-- 提示信息样式 -->
          <div class="remind-notice" v-show=" emailOut !== '' && emailVerifyInSide !== '1' ">
            <div class="remindinfo">
              <img src="/static/img/login/notice.png">
              <div class="remind-notice-text">{{$t(remindNotice)}}</div>
            </div>
          </div>
          <!-- 操作成功消息样式 -->
          <div class="remind" v-show="remindSuccess">
            <div class="remindinfo">
              <div class="img-success">
                <img src="https://res.roompai.com/static/img/account/my-payment-yes.png">
              </div>
              <div class="remind-text">{{$t(remindSuccess)}}</div>
            </div>
          </div>
          <!-- 操作失败消息样式 -->
          <div class="remind-faild" v-show="remindFail">
            <div class="remindinfo">
              <div class="img-faild">
                <img src="https://res.roompai.com/static/img/account/my-error.png">
              </div>
              <div class="remind-text-faild">{{$t(remindFail)}}</div>
            </div>
          </div>
        </div>
        <div class="account-detail-main-line">
          <div class="account-detail-main-line-center">
            <div class="clearBoth account-roominfo-clear"></div>
            <div class="title">
              {{ $t('email') }}
              <div v-if="emailOut !== ''" class="icon_green_solid">{{ $t('iconBound') }}</div>
              <div v-if="emailOut !== '' && emailVerifyInSide !== '1'" class="icon_red_hollow">{{ $t('iconNotVerified') }}</div>
              <div v-if="emailOut !== '' && emailVerifyInSide === '1'" class="icon_green_hollow">{{ $t('iconVerified') }}</div>
            </div>
            <div class="clearBoth account-roominfo-clear-5"></div>
            <el-input v-model.trim="emailInside" :disabled="emailOut !== ''"></el-input>
            <div class="errorNotice" v-show="emailError">{{$t(emailErrorMsg)}}</div>
          </div>
        </div>
        <div class="account-detail-main-line" v-show="!emailOut">
          <div class="account-detail-main-line-center">
            <div class="clearBoth account-roominfo-clear"></div>
            <div class="title">{{ $t('password') }}</div>
            <div class="clearBoth account-roominfo-clear-5"></div>
            <el-input type="password" v-model.trim="password" show-password></el-input>
            <div class="errorNotice" v-show="passWordError">{{$t('passWordError')}}</div>
          </div>
        </div>
        <div class="account-detail-main-line" v-show="!emailOut">
          <div class="account-detail-main-line-center">
            <div class="clearBoth account-roominfo-clear"></div>
            <div class="title">{{ $t('retypePassword') }}</div>
            <div class="clearBoth account-roominfo-clear-5"></div>
            <el-input type="password" v-model.trim="retypePassword" show-password></el-input>
            <div class="errorNotice" v-show="passWordTwoError">{{$t('passWordTwoError')}}</div>
          </div>
        </div>
        <div class="button">
          <!--修改邮箱-绑定邮箱按钮-->
          <el-button v-show="!emailOut" class="buttonBindEmail width96" @click="bindEmail()">{{ $t('buttonBindEmail') }}</el-button>
          <!--修改邮箱-解除绑定按钮-->
          <el-button v-show="emailOut" class="buttonUnBindEmail" :class="{'buttonUnBindEmail': true, 'width96': emailVerifyInSide === '1', 'width35': emailVerifyInSide !== '1'}" @click="unbindEmail()">{{ $t('buttonUnBindEmail') }}</el-button>
          <!--修改邮箱-验证邮箱按钮-->
          <el-button v-show="emailOut && emailVerifyInSide !== '1'" class="buttonCheckEmail width55" @click="checkEmail()">{{ $t('buttonCheckEmail') }}</el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 修改用户信息-手机号  -->
    <el-drawer :visible.sync="mobileSetupInside" :title="$t('mobile')" size="85%" class="search-dialog" :with-header="false" :modal="false" @close="dialog_close('mobileSetup')">
      <div style="height:60px; background-color:rgba(79, 76, 76, 1);">
        <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;">{{$t('mobile')}}</div>
      </div>
      <div class="account-detail-main">
        <div class="notice">
          <!-- 操作成功消息样式 -->
          <div class="remind" v-show="remindMobileSuccess">
            <div class="remindinfo">
              <div class="img-success">
                <img src="https://res.roompai.com/static/img/account/my-payment-yes.png">
              </div>
              <div class="remind-text">{{$t(remindMobileSuccess)}}</div>
            </div>
          </div>
          <!-- 操作失败消息样式 -->
          <div class="remind-faild" v-show="remindMobileFail">
            <div class="remindinfo">
              <div class="img-faild">
                <img src="https://res.roompai.com/static/img/account/my-error.png">
              </div>
              <div class="remind-text-faild">{{$t(remindMobileFail)}}</div>
            </div>
          </div>
        </div>
        <div class="account-detail-main-line" v-show="mobileOut !== ''">
          <div class="account-detail-main-line-center">
            <div class="clearBoth account-roominfo-clear"></div>
            <div class="title">{{ $t('oldmobile') }}</div>
            <div class="clearBoth account-roominfo-clear-5"></div>
            <el-select style="width:25%;font-size: 10px" v-model="oldSelectTel" :placeholder="$t('pleaseSelect')">
              <el-option v-for="item in telOptions" :label="item.telnum" :key="item.id" :value="item.id">{{item.value}}</el-option>
            </el-select>
            <el-input style="width:73%;font-size: 10px" :placeholder="$t('oldmobile')" v-model.trim="oldMobileInput"></el-input>
            <div class="errorNotice" v-show="oldMobileError">{{$t(oldMobileError)}}</div>
          </div>
        </div>
        <div class="account-detail-main-line">
          <div class="account-detail-main-line-center">
            <div class="clearBoth account-roominfo-clear"></div>
            <div class="title">{{ $t('newmobile') }}</div>
            <div class="clearBoth account-roominfo-clear-5"></div>
            <el-select style="width:25%;font-size: 10px" v-model="newSelectTel" :placeholder="$t('pleaseSelect')">
              <el-option v-for="item in telOptions" :label="item.telnum" :key="item.id" :value="item.id">{{item.value}}</el-option>
            </el-select>
            <el-input style="width:73%;font-size: 10px" :placeholder="$t('newmobile')" v-model.trim="newMobileInput"></el-input>
            <div class="errorNotice" v-show="newMobileError">{{$t(newMobileError)}}</div>
          </div>
        </div>
        <div class="account-detail-main-line">
          <div class="account-detail-main-line-center">
            <div class="clearBoth account-roominfo-clear-5"></div>
            <el-input style="width: 65%;font-size: 10px" type="text" v-model.trim="codeInput" :placeholder="$t('inputMobileCode')"></el-input>
            <el-button style="width: 32%;float: right;" class="send_mobile_code" @click="getMobileCode()">
              <span v-show="this.expireTime === 0">{{$t('getMobileCode')}}</span>
              <span v-show="this.expireTime > 0">{{expireTime}}S</span>
            </el-button>
            <div class="errorNotice" v-show="mobileCodeError">{{$t(mobileCodeError)}}</div>
          </div>
        </div>
        <div class="button">
          <!--修改手机号-取消按钮-->
          <el-button class="buttonCancel width35" @click="mobileSetupInside=false">{{ $t('buttonCancel') }}</el-button>
          <!--修改手机号-确定按钮-->
          <el-button class="buttonSave width55" @click="bindMobile()">{{ $t('buttonBindMobile') }}</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {modifyUserInfo, unbindEmail, bindEmail, checkEmail, sendMobileCode, bindMobile} from '@/request/user.js'

export default {
  name: 'accountSetup',
  props: ['nameSetup', 'emailSetup', 'mobileSetup', 'firstname', 'lastname', 'email', 'mobile', 'emailVerify', 'conver'],
  data () {
    return {
      nameSetupInside: false,
      emailSetupInside: false,
      firstnameInside: '',
      lastnameInside: '',
      emailInside: '',
      emailVerifyInSide: '0',
      firstnameOut: '',
      lastnameOut: '',
      emailOut: '',
      password: '',
      retypePassword: '',
      emailError: false,
      emailErrorMsg: 'emailError',
      lastEmailSubDomainBlocklist: '',
      lastnameError: false,
      firstnameError: false,
      passWordError: false,
      passWordTwoError: false,
      remindNotice: 'mobileEmailCheckNotice',
      remindSuccess: '',
      remindFail: '',
      mobileSetupInside: false,
      mobileOut: '',
      remindMobileSuccess: '',
      remindMobileFail: '',
      telOptions: [],
      telOptionsEn: [{id: 42, value: 'China +86', telnum: '+86'}, {id: 216, value: 'United States +1', telnum: '+1'}, {id: 36, value: 'Canada +1', telnum: '+1'}],
      telOptionsCn: [{id: 42, value: '中国 +86', telnum: '+86'}, {id: 216, value: '美国 +1', telnum: '+1'}, {id: 36, value: '加拿大 +1', telnum: '+1'}],
      oldSelectTel: 42,
      newSelectTel: 42,
      oldMobileInput: '',
      oldMobileError: '',
      newMobileInput: '',
      newMobileError: '',
      codeInput: '',
      mobileCodeError: '',
      expireTime: 0,
      codeTimeExpire: '',
      converInSide: ''
    }
  },
  watch: {
    nameSetup: function (news) {
      this.nameSetupInside = news
      if (news === true) {
        this.emailSetupInside = false
        this.mobileSetupInside = false
      }
    },
    emailSetup: function (news) {
      this.emailSetupInside = news
      if (news === true) {
        this.nameSetupInside = false
        this.mobileSetupInside = false
      }
    },
    mobileSetup: function (news) {
      this.mobileSetupInside = news
      if (news === true) {
        this.nameSetupInside = false
        this.emailSetupInside = false
      }
    },
    firstname: function (firstname) {
      this.firstnameInside = firstname
      this.firstnameOut = firstname
    },
    lastname: function (lastname) {
      this.lastnameInside = lastname
      this.lastnameOut = lastname
    },
    email: function (email) {
      this.emailInside = email
      this.emailOut = email
    },
    mobile: function (mobile) {
      this.mobileOut = mobile
    },
    emailVerify: function (emailVerify) {
      this.emailVerifyInSide = emailVerify
    },
    conver: function (conver) {
      this.converInSide = conver
    }
  },
  created () {
    //
  },
  mounted () {
    this.telOptions = this.common.languageSet(this) === 'en' ? this.telOptionsEn : this.telOptionsCn
  },
  methods: {
    getMobileCode () {
      if (this.newMobileInput === '') {
        this.newMobileError = 'pleaseValidPhone'
        return false
      }
      if (this.expireTime > 0) {
        return false
      }
      var that = this
      this.remindMobileSuccess = ''
      this.remindMobileFail = ''
      this.oldMobileError = ''
      this.newMobileError = ''
      this.mobileCodeError = ''
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var sessionid = this.common.sessionidGet(this)
      let token = localStorage.getItem('token')
      let dataJson = {
        'token': token,
        'oldAreaCode': this.oldSelectTel,
        'oldMobile': this.oldMobileInput,
        'newAreaCode': this.newSelectTel,
        'newMobile': this.newMobileInput,
        'time': time,
        'sessionid': sessionid,
        'operation': 'sendMobileCode'
      }
      var data = this.common.encryptionData(dataJson, this)
      console.log(data)
      sendMobileCode(data).then(res => {
        console.log(res)
        var responseTime = parseInt(new Date().getTime())
        this.loadPageView(data, res, requestTime, responseTime)
        if (res.flag === '200') {
          that.expireTime = 60
          that.codeTimeExpire = setInterval(function () {
            console.log(that.expireTime)
            if (that.expireTime === 0) {
              clearInterval(that.codeTimeExpire)
            } else {
              that.expireTime = that.expireTime - 1
            }
          }, 1000)
          this.remindMobileSuccess = 'sendCodeSuccess'
          console.log('短信发送成功')
        } else if (res.flag === '201') {
          this.oldMobileError = res.msg
        } else {
          this.newMobileError = res.msg
        }
      })
    },
    bindMobile () {
      if (this.newMobileInput === '') {
        this.newMobileError = 'pleaseValidPhone'
        return false
      }
      if (this.codeInput === '') {
        this.mobileCodeError = 'pleaseValidMobileCode'
        return false
      }
      this.newMobileError = ''
      this.mobileCodeError = ''
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var sessionid = this.common.sessionidGet(this)
      let token = localStorage.getItem('token')
      let dataJson = {
        'token': token,
        'newAreaCode': this.newSelectTel,
        'newMobile': this.newMobileInput,
        'code': this.codeInput,
        'time': time,
        'sessionid': sessionid,
        'operation': 'BindMobile'
      }
      var data = this.common.encryptionData(dataJson, this)
      bindMobile(data).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.loadPageView(data, res, requestTime, responseTime)
        if (res.flag === '200') {
          this.$emit('closepop', data = {
            'type': 'mobileSetup',
            'mobile': this.newMobileInput
          })
          this.$message({
            type: 'success',
            message: this.$t('bindMobileSuccess')
          })
        } else {
          this.mobileCodeError = res.msg
        }
      })
    },
    dialog_close: function (type) {
      this.remindFail = ''
      this.remindSuccess = ''
      this.remindNotice = 'mobileEmailCheckNotice'
      var data = {}
      if (type === 'nameSetup') {
        data = {
          'type': type,
          'lastname': this.lastnameOut,
          'firstname': this.firstnameOut
        }
      } else if (type === 'mobileSetup') {
        data = {
          'type': type,
          'mobile': this.mobileOut
        }
      } else {
        data = {
          'type': type,
          'email': this.emailOut,
          'emailVerify': this.emailVerifyInSide
        }
      }
      this.$emit('closepop', data)
    },
    /**
     * 检验是否英文.
     */
    checkEnglish (refInfo) {
      let refName = this.$refs[refInfo].value
      // 姓名允许为空字符串, 默认为正常
      var checkRes = true
      if (refName) {
        var regExp = /^[A-Za-z]+$/
        checkRes = regExp.test(refName)
      }
      console.log(checkRes)
      if (refInfo === 'firstName') {
        this.firstnameError = !checkRes
      } else if (refInfo === 'lastName') {
        this.lastnameError = !checkRes
      }
    },
    // 修改用户姓名.
    editAccount () {
      if (this.firstnameError || this.lastnameError) {
        return false
      }
      // 提交修改的用户信息
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        let locationHref = window.document.location.href
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        // this.$router.push({name: 'login', query: {'source': this.source}})
        var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
        if (this.converInSide === 1 || this.converInSide === '1') {
          newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.converInSide}, 'obj')
        }
        this.$router.push({name: 'login', params: {'querys': newQuerys}})
      }
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {'token': token, 'time': time, 'lastname': this.lastnameInside, 'firstname': this.firstnameInside, 'sessionid': sessionid}
      var data = this.common.encryptionData(dataJson, this)
      modifyUserInfo(data).then(res => {
        if (res.flag === '200') {
          this.$emit('closepop', data = {
            'type': 'nameSetup',
            'lastname': this.lastnameInside,
            'firstname': this.firstnameInside
          })
          this.$message({
            type: 'success',
            message: this.$t('modifySuccess')
          })
        } else {
          this.$message({
            type: 'error',
            message: this.$t('modifyFail')
          })
        }
      })
    },
    unbindEmail () {
      this.remindNotice = ''
      this.remindSuccess = ''
      this.remindFail = ''
      let token = localStorage.getItem('token')
      let dataJson = {'time': parseInt(new Date().getTime() / 1000), 'token': token, 'operation': 'unbindEmail'}
      let data = this.common.encryptionData(dataJson, this)
      unbindEmail(data).then(res => {
        if (res.flag === '200') {
          this.emailOut = ''
          this.emailInside = ''
          this.emailVerifyInSide = '0'
          // 提示成功.
          this.remindSuccess = 'unbindEmailSuccessNotice'
        } else {
          // 提示错误
          this.remindFail = res.msg
        }
      })
    },
    checkEmailValue () {
      let emailSubDomain = this.emailInside.split('@')[1] || null
      const pattern = /^([a-zA-Z]|[0-9])(\.|\w|-)+@([a-zA-Z0-9])(\.|\w|-)+.([a-zA-Z]{2,})$/
      if (this.emailInside === '') {
        this.emailError = true
        this.emailErrorMsg = 'emailError'
      } else if (!pattern.test(this.emailInside)) {
        this.emailError = true
        this.emailErrorMsg = 'emailError'
      } else if (emailSubDomain === this.lastEmailSubDomainBlocklist) {
        this.emailError = true
        this.emailErrorMsg = 'emailSubDomainBlocklist'
      } else {
        this.emailError = false
      }
    },
    // 绑定用户邮箱.
    bindEmail () {
      this.remindNotice = ''
      this.remindSuccess = ''
      this.remindFail = ''
      this.checkEmailValue()
      this.passWordError = this.password.length < 6
      this.passWordTwoError = this.password !== this.retypePassword
      if (this.emailError || this.passWordError || this.passWordTwoError) {
        return false
      }
      let token = localStorage.getItem('token')
      let dataJson = {'operation': 'bindEmail', 'time': parseInt(new Date().getTime() / 1000), 'token': token, 'email': this.emailInside, 'password': this.password, 'passwordTwo': this.retypePassword}
      let data = this.common.encryptionData(dataJson, this)
      bindEmail(data).then(res => {
        if (res.flag === '200') {
          this.emailOut = this.emailInside
          this.emailVerifyInSide = '0'
          // 绑定成功提醒
          this.remindNotice = 'mobileBindEmailSuccessNotice'
        } else if (res.flag === '104') {
          this.lastEmailSubDomainBlocklist = this.emailInside.split('@')[1] || null
          this.emailError = true
          this.emailErrorMsg = 'emailSubDomainBlocklist'
        } else {
          // 绑定失败提醒
          this.remindFail = res.msg
        }
      })
    },
    // 验证邮箱.
    checkEmail () {
      this.remindNotice = ''
      this.remindSuccess = ''
      this.remindFail = ''
      let token = localStorage.getItem('token')
      let dataJson = {'operation': 'checkEmail', 'time': parseInt(new Date().getTime() / 1000), 'token': token}
      let data = this.common.encryptionData(dataJson, this)
      checkEmail(data).then(res => {
        if (res.flag === '200') {
          this.emailOut = this.emailInside
          this.emailVerifyInSide = '0'
          // 绑定邮件发送成功提醒
          this.remindNotice = 'mobileEmailCheckNotice'
        } else if (res.flag === '102') {
          this.emailVerifyInSide = '1'
          this.emailOut = res.email
          // 绑定邮箱成功提示.
          this.remindSuccess = 'mobileCheckEmailVerifySuccess'
        } else {
          // 绑定失败提醒
          this.remindFail = res.msg
        }
      })
    }
  }
}
</script>

<style scoped>
.account-detail-main{width:94%;height:280px;background:white; margin: 0 auto;}
.account-detail-main .account-detail-main-line{width: 100%;height: 101px;padding-top:5px}
.account-detail-main .account-detail-main-line .account-detail-main-line-center{width: 94%;height: 100%;margin:0 auto;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;color: #4F4C4C;font-size: 14px;}
.account-detail-main .account-detail-main-line .title{height: 20px;line-height: 20px;margin:5px 0px 7px 0px}
.account-detail-main .account-detail-main-line input{height: 36px;margin-top: 5px;margin-bottom: 20px}
.account-detail-main .button {width: 100%;text-align: center;position: absolute;bottom: 30px;left: 0;height: 50px;}
.buttonCancel, .buttonUnBindEmail {display: inline-block;height: 44px;font-weight: 400;font-size: 16px;color: #4F4C4C;cursor: pointer;border: 0;padding: 1px 6px !important;}

.buttonSave, .buttonBindEmail, .buttonCheckEmail{
  display: inline-block;
  height: 44px;
  background-color: rgba(79, 76, 76, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(79, 76, 76, 1);
  border-radius: 6px;
  -moz-box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.24705882352941178);
  -webkit-box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.24705882352941178);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.24705882352941178);
  font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: rgb(255, 255, 255);
  cursor: pointer;
}
.buttonSave:hover, .buttonBindEmail:hover, .buttonUnBindEmail:hover, .buttonCheckEmail:hover,.buttonCancel:hover {
  background-color:rgba(252, 210, 5, 1);
  border-color:rgba(252, 210, 5, 1);
}

.width96 {width: 96%;border: 1px solid rgba(79, 76, 76, 1);margin: 0px;}
.width35 {width: 35%}
.width55 {width: 55%}

.errorNotice {
  display: flex;
  font-weight: 400;
  font-size: 12px;
  color: rgb(225, 45, 45);
  height: 20px;
  margin-top: 8px;
}

.icon_green_solid {
  display: inline-block;
  padding: 0px 5px;
  height: 20px;
  background: inherit;
  background-color: rgba(115, 209, 61, 1);
  border: none;
  border-radius: 4px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-weight: 400;
  font-style: normal;
  font-size: 12px;
  color: #FFFFFF;
  text-align: center;
  line-height: 20px;
}

.icon_green_hollow {
  display: inline-block;
  padding: 0px 5px;
  height: 20px;
  background: inherit;
  background-color: rgba(246, 255, 237, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(183, 235, 143, 1);
  border-radius: 4px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-weight: 400;
  font-style: normal;
  font-size: 12px;
  color: #52C41A;
  text-align: center;
  line-height: 20px;
}

.icon_blue_solid {
  display: inline-block;
  padding: 0px 5px;
  height: 20px;
  background: inherit;
  background-color: rgba(64, 169, 255, 1);
  border: none;
  border-radius: 4px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-weight: 400;
  font-style: normal;
  font-size: 12px;
  color: #FFFFFF;
  text-align: center;
  line-height: 20px;
}

.icon_red_hollow {
  display: inline-block;
  padding: 0px 5px;
  height: 20px;
  background: inherit;
  background-color: rgba(255, 242, 232, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(255, 187, 150, 1);
  border-radius: 4px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-weight: 400;
  font-style: normal;
  font-size: 12px;
  color: #FA541C;
  text-align: center;
  line-height: 20px;
}

/*提示*/
.notice {min-height: 56px;}
.remind-notice{border-width: 0px;min-height: 56px;background: inherit;border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.remind-notice-text{line-height: 20px; font-size: 14px;font-weight: 400;color:#5392F9;display:inline-block;width:90%;margin-top:10px}
.remind-notice img {width: 18px;height: 18px;margin: 10px 10px 0px 10px}
/* 登录提醒 */
.remind{ border-width: 0px;height: 56px;background: inherit;background-color: rgba(240, 249, 235);border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.remindinfo{padding-right: 18px;display: flex;justify-content: center;align-items: center; line-height:56px;}
.img-success{ margin: 18px;width: 18px;height: 18px;background-color: rgba(103, 194, 58, 1);border: none;border-radius: 15px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;text-align: center;line-height: normal;display:inline-block; margin-right:10px;}
.remind-text{color: #67C23A;line-height: 20px; font-size:14px;display:inline-block;width:90%;}
/* 失败 */
.remind-faild{overflow: hidden;background: inherit;background-color: rgba(254, 240, 240, 1);border-width: 0px;height: 56px;border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.img-faild{margin: 18px;width: 18px;height: 18px;background-color: rgba(245, 108, 108, 1);border: none;border-radius: 15px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;text-align: center;line-height: normal;display:inline-block; margin-right:10px;}
.remind-text-faild{color: #F56C6C;line-height: 20px; font-size:14px;display:inline-block;width:90%;}

.img-faild img, .img-success img, .img-notice img{width:12px; height:12px;display: block;margin: 3px auto;}

.send_mobile_code{padding: 12px 0 !important;width: 100%;height: 40px; font-size:12px; background-color: rgba(79, 76, 76, 1);box-sizing: border-box;border: 1px solid rgba(79, 76, 76, 1);border-radius: 4px;-moz-box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.34901960784313724);color: #FFFFFF;}
.send_mobile_code:hover{
  background-color:rgba(252, 210, 5, 1);
  border-color:rgba(252, 210, 5, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/account/AccountModify.vue